import React from 'react';
import moment from 'moment-timezone';
import {
  faCircleNotch,
  faDotCircle,
  faBan
} from '@fortawesome/pro-solid-svg-icons';

import { Row, Col } from '../../../../grid';
import StatusIndicator from '../../status/status-indicator';
import { LoadingBlock } from '../../loading/progress';
import { AppSummaryInstanceProps, SummaryCell } from '../index';

import { useGetSummary } from '../../../../libs/summary';
import { IEpxPPDepressSchedule } from '../../../../libs/apps/epxppdepress';

export interface EpxPPDepressSummaryResponse {
  schedule?: IEpxPPDepressSchedule;
}

const EpxPPDepressSummary = ({
  params
}: AppSummaryInstanceProps): JSX.Element => {
  const { data, isLoading } = useGetSummary<EpxPPDepressSummaryResponse>(
    '/epxppdepress/data_summary/',
    params
  );
  if (!data || isLoading) {
    return <LoadingBlock />;
  }
  const { schedule } = data;
  if (!schedule) {
    return null;
  }
  const birthAt = moment.tz(schedule.birthDate, schedule.tz);
  const createdAt = moment.tz(schedule.createdAt, schedule.tz);
  const { deltas } = schedule;
  return (
    <div>
      <h4 className="mb-8">
        Survey Schedule - Birth Date: {birthAt.format('MM/DD/YYYY')}
      </h4>
      <Row>
        {deltas.map((delta, i) => {
          let label = `${delta} Weeks`;
          const month = delta / 4;
          if (Math.floor(month) === month) {
            label = `${month} ${month === 1 ? 'Month' : 'Months'}`;
          }
          label += ' Post Birth';
          const time = birthAt.clone().add(delta, 'weeks').startOf('day');
          let icon = faDotCircle;
          let status = 'Sent';
          if (time > moment()) {
            icon = faCircleNotch;
            status = 'Scheduled';
          } else if (time < createdAt) {
            icon = faBan;
            status = 'Before Enrollment';
          }
          return (
            <Col key={i} sm={6}>
              <SummaryCell
                label={label}
                value={time.format('MM/DD/YY')}
                status={<StatusIndicator className="mr-4" indicator={icon} />}
                unit={status}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default EpxPPDepressSummary;
